import { ChangeEvent, FC, useState } from 'react';
import { Button, TextField, Box, BoxProps, InputAdornment, IconButton } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
import { toTitleCase } from '@shared/utils/utilsOld';
import VisuallyHiddenInput from '@shared/components/ui/VisuallyHiddenInput';

interface FileInputProps extends BoxProps {
    accept?: string;
    onFileSelect?: (file: File | null) => void;
}

const FileInput: FC<FileInputProps> = ({ accept = '*', onFileSelect, sx, defaultValue, ...props }) => {
    const [fileName, setFileName] = useState<string>(defaultValue ? String(defaultValue) : '');
    const { t } = useTranslation();

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setFileName(file.name);
            if (onFileSelect) {
                onFileSelect(file);
            }
        }
    };

    const handleClear = () => {
        setFileName('');
        if (onFileSelect) {
            onFileSelect(null);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                ...sx,
            }}
            {...props}
        >
            <VisuallyHiddenInput type="file" accept={accept} id="file-upload" onChange={handleFileChange} />

            <label htmlFor="file-upload">
                <Button
                    variant="contained"
                    size="small"
                    sx={{ whiteSpace: 'nowrap' }}
                    component="span"
                    startIcon={<UploadFileIcon />}
                >
                    {t('select')} {t('file')}
                </Button>
            </label>

            {/* Поле с именем файла */}
            <TextField
                size="small"
                value={fileName}
                variant="outlined"
                placeholder={toTitleCase(t('file') + ' ' + t('not_selected'))}
                disabled
                fullWidth
                InputProps={{
                    endAdornment: fileName && (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClear} edge="end">
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
};

export default FileInput;
